var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_c('a',{staticClass:"alert-link",attrs:{"href":"#"}},[_c('i',{staticClass:"fas fa-exclamation-circle"}),_vm._v(" "+_vm._s(_vm.comunicado))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42dc7453","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/items/ComunicadoVue.vue
// module id = BBoj
// module chunks = 1